import ModalViewModel from 'infra/ModalViewModel'
import Job from 'jobs/Job'
import JobStore from 'jobs/JobStore'
import { task } from 'mobx-task'
import { Router } from 'types/definitions'
import link from 'infra/link'

/**
 * View model for managing the Forfeit dialog.
 */
export default class ForfeitViewModel extends ModalViewModel {
  constructor(
    public job: Job,
    private jobStore: JobStore,
    private router: Router,
  ) {
    super()
  }

  /**
   * Forfeits the job.
   */
  forfeit = task.resolved(async () => {
    await this.jobStore.forfeit(this.job)
    this.close()
    this.router.push(link.jobs())
  })
}
